import $ from 'jquery';

$(() => {
  $('.phone-mask').mask('+38 (000) 000 00 00');
});
